define('base/MbiBackgroundImage',[
	'jquery',
	'base/MbiHelper',
	'project/MbiConfig',
	'base/MbiMediaQuery'
], function(
	$,
	_,
	mbiConfig,
	mbiMq
) {
	'use strict';

	// ----------------------------------------------------------------
	// BACKGROUND IMAGE SRCSET
	// ----------------------------------------------------------------

	var module = {

		container: '.background',

		styles: '',
		before: '<style data-background-image>',
		after: '</style>',

		init: function() {

			$(module.container).each(function() {

				var	$this = $(this),
					set = $this.attr('data-srcset');

				if(typeof set == 'undefined') {
					return;
				}
				var sources = set.split(','),
					delay = $this.attr('data-delay'),
					data = {},
					id = $this.attr('id');

				$.each(sources, function(i, source) {

					var trim = source.trim(),
						split = trim.split(' '),
						url = split[0],
						area = split[1]; // e.g. lap+

					module.styles += 	'@media '+mbiMq.mq[area]+' {';
					module.styles += 		'#'+id+' { background-image: url('+url+'); }';
					module.styles += 	'}';

				});

			});

			$('style[data-background-image]').remove(); // remove previous stylesheet if placed

			$('head').append(module.before+module.styles+module.after);

		},

	};

	module.init();

	mbiConfig.modules.MbiBackgroundImage = {
		'init': 	true,
		'version':	'2.0.0'
	};

	return module;

});
